import { t } from "../../../hooks/useAppTranslation";

export const PreviewUnavailable = () => {
    return <p className="info-text" role="status">{ t('g-preview-unavailable') }</p>
};
